import { Toast } from 'antd-mobile';
import { cpListInfo, cpListDishInfo, cpListRank, cpListCollect, cpListShowUnlockScenet } from '@/services/activity';
const sortFun = (a, b, c) => {
  if (a > b && a > c) {
    return 'first';
  } else if (a < b && a < c) {
    return 'third';
  } else {
    return 'second';
  }
};
export default {
  namespace: 'cpList',
  state: {
    // activityId: 123456,
    // title: 'Eid Al-Fitr Celebration',
    // titleUrl: 'https://www.cdnmole.com/online/cms/image/6d0ef43222c5c0192a6002e6da6acb3.png',
    // activityStatus: 1,
    // endTime: 1651555200,
    // rules: '参与方式：在指定时间内完成相关任务；奖励：金币、红包、礼物等。',
    // ruleUrl: 'http',
    // limitedGifts: [
    //   {
    //     giftId: 1234,
    //     url: 'https://www.cdnmole.com/test/cms/image/f754aa9bf894f0b54ec65c3aeded3701.jpeg',
    //     value: 50,
    //   },
    //   {
    //     giftId: 5678,
    //     url: 'https://www.cdnmole.com/test/cms/image/f754aa9bf894f0b54ec65c3aeded3701.jpeg',
    //     value: 100,
    //   },
    //   {
    //     giftId: 56748,
    //     url: 'https://www.cdnmole.com/test/cms/image/f754aa9bf894f0b54ec65c3aeded3701.jpeg',
    //     value: 10000,
    //   },
    // ],
    // dailyRewards: [
    //   {
    //     title: '第一天奖励',
    //     rewardInfos: [
    //       {
    //         url: 'https://www.cdnmole.com/test/cms/image/f754aa9bf894f0b54ec65c3aeded3701.jpeg',
    //         name: '100金币',
    //         unit: '枚',
    //       },
    //       {
    //         url: 'https://www.cdnmole.com/test/cms/image/f754aa9bf894f0b54ec65c3aeded3701.jpeg',
    //         name: '20元红包',
    //         unit: '个',
    //       },
    //     ],
    //   },
    // ],
    // totalRewards: [
    //   {
    //     title: '第一天奖励',
    //     rewardInfos: [
    //       {
    //         url: 'https://www.cdnmole.com/test/cms/image/f754aa9bf894f0b54ec65c3aeded3701.jpeg',
    //         name: '100金币',
    //         unit: '枚',
    //       },
    //       {
    //         url: 'https://www.cdnmole.com/test/cms/image/f754aa9bf894f0b54ec65c3aeded3701.jpeg',
    //         name: '20元红包',
    //         unit: '个',
    //       },
    //     ],
    //   },
    //   {
    //     title: '第一天奖励',
    //     rewardInfos: [
    //       {
    //         url: 'https://www.cdnmole.com/test/cms/image/f754aa9bf894f0b54ec65c3aeded3701.jpeg',
    //         name: '100金币',
    //         unit: '枚',
    //       },
    //       {
    //         url: 'https://www.cdnmole.com/test/cms/image/f754aa9bf894f0b54ec65c3aeded3701.jpeg',
    //         name: '20元红包',
    //         unit: '个',
    //       },
    //     ],
    //   },
    //   {
    //     title: '第一天奖励',
    //     rewardInfos: [
    //       {
    //         url: 'https://www.cdnmole.com/test/cms/image/f754aa9bf894f0b54ec65c3aeded3701.jpeg',
    //         name: '100金币',
    //         unit: '枚',
    //       },
    //       {
    //         url: 'https://www.cdnmole.com/test/cms/image/f754aa9bf894f0b54ec65c3aeded3701.jpeg',
    //         name: '20元红包',
    //         unit: '个',
    //       },
    //     ],
    //   },
    // ],
    // id: 3, // 菜品id
    // url: 'https://www.cdnmole.com/online/cms/image/dadb92fec13584f6fdf07c4174031fdd.png', // 菜品图片
    // currentCoin: 2000, // 当前金币
    // endCoin: 10000, // 总金币
    // startCoin: 0, // 当前总的金币池
    // tableDisplayList: [
    //   // 桌位用户信息
    //   {
    //     id: 1, // 座位用户位置
    //     name: 'John', // 座位用户姓名
    //     url: 'https://www.cdnmole.com/test/cms/image/f754aa9bf894f0b54ec65c3aeded3701.jpeg', // 座位用户头像
    //     userId: 1, // 用户userId
    //     date: '4.19',
    //   },
    //   {
    //     id: 2,
    //     name: 'Mary',
    //     url: 'https://www.cdnmole.com/test/cms/image/f754aa9bf894f0b54ec65c3aeded3701.jpeg',
    //     userId: 1, // 用户userId
    //     date: '4.20',
    //   },
    //   {
    //     id: 3,
    //     date: '4.21',
    //   },
    //   {
    //     id: 4,
    //     date: '4.22',
    //   },
    //   {
    //     id: 5,
    //     date: '4.23',
    //   },
    // ],
    // dishInfoList: [
    //   // 菜品信息
    //   {
    //     id: 0, // 菜品索引
    //     url: 'https://www.cdnmole.com/online/cms/image/c826b12beff31347ec47273779b2dc6c.png', // 菜品图片url
    //     status: 2, // 座位用户状态1:未接锁，2:待，3:已
    //     dishRewardList: [
    //       // 当前菜品对应的奖励
    //       {
    //         id: 1, // 奖励id
    //         url: 'https://www.cdnmole.com/test/cms/image/f754aa9bf894f0b54ec65c3aeded3701.jpeg', // 奖励url
    //         unit: 3, // 数量
    //         name: '100金币',
    //       },
    //       {
    //         id: 2,
    //         url: 'https://www.cdnmole.com/test/cms/image/f754aa9bf894f0b54ec65c3aeded3701.jpeg',
    //         unit: 1,
    //         name: '100金币',
    //       },
    //       {
    //         id: 3,
    //         url: 'https://www.cdnmole.com/test/cms/image/f754aa9bf894f0b54ec65c3aeded3701.jpeg',
    //         unit: 1,
    //         name: '100金币',
    //       },
    //     ],
    //   },
    //   {
    //     id: 1, // 菜品索引
    //     url: 'https://www.cdnmole.com/online/cms/image/84094ef569b127787dbb1c0c07bc5b27.png', // 菜品图片url
    //     status: 2, // 座位用户状态1:未接锁，2:待，3:已
    //     dishRewardList: [
    //       // 当前菜品对应的奖励
    //       {
    //         id: 1, // 奖励id
    //         url: 'https://www.cdnmole.com/test/cms/image/f754aa9bf894f0b54ec65c3aeded3701.jpeg', // 奖励url
    //         unit: 3, // 数量
    //         name: '100金币',
    //       },
    //       {
    //         id: 2,
    //         url: 'https://www.cdnmole.com/test/cms/image/f754aa9bf894f0b54ec65c3aeded3701.jpeg',
    //         unit: 1,
    //         name: '100金币',
    //       },
    //       {
    //         id: 3,
    //         url: 'https://www.cdnmole.com/test/cms/image/f754aa9bf894f0b54ec65c3aeded3701.jpeg',
    //         unit: 1,
    //         name: '100金币',
    //       },
    //     ],
    //   },
    //   {
    //     id: 2, // 菜品索引
    //     url: 'https://www.cdnmole.com/online/cms/image/dadb92fec13584f6fdf07c4174031fdd.png', // 菜品图片url
    //     status: 2, // 座位用户状态1:未接锁，2:待，3:已
    //     dishRewardList: [
    //       // 当前菜品对应的奖励
    //       {
    //         id: 1, // 奖励id
    //         url: 'https://www.cdnmole.com/test/cms/image/f754aa9bf894f0b54ec65c3aeded3701.jpeg', // 奖励url
    //         unit: 3, // 数量
    //         name: '100金币',
    //       },
    //       {
    //         id: 2,
    //         url: 'https://www.cdnmole.com/test/cms/image/f754aa9bf894f0b54ec65c3aeded3701.jpeg',
    //         unit: 1,
    //         name: '100金币',
    //       },
    //       {
    //         id: 3,
    //         url: 'https://www.cdnmole.com/test/cms/image/f754aa9bf894f0b54ec65c3aeded3701.jpeg',
    //         unit: 1,
    //         name: '100金币',
    //       },
    //     ],
    //   },
    //   {
    //     id: 3, // 菜品索引
    //     url: 'https://www.cdnmole.com/online/cms/image/72010ead70f97f7dddf7e6b960ef0d26.png', // 菜品图片url
    //     status: 2, // 座位用户状态1:未接锁，2:待，3:已
    //     dishRewardList: [
    //       // 当前菜品对应的奖励
    //       {
    //         id: 1, // 奖励id
    //         url: 'https://www.cdnmole.com/test/cms/image/f754aa9bf894f0b54ec65c3aeded3701.jpeg', // 奖励url
    //         unit: 3, // 数量
    //         name: '100金币',
    //       },
    //       {
    //         id: 2,
    //         url: 'https://www.cdnmole.com/test/cms/image/f754aa9bf894f0b54ec65c3aeded3701.jpeg',
    //         unit: 1,
    //         name: '100金币',
    //       },
    //       {
    //         id: 3,
    //         url: 'https://www.cdnmole.com/test/cms/image/f754aa9bf894f0b54ec65c3aeded3701.jpeg',
    //         unit: 1,
    //         name: '100金币',
    //       },
    //     ],
    //   },
    //   {
    //     id: 4, // 菜品索引
    //     url: 'https://www.cdnmole.com/online/cms/image/216c821600dde9c1c033c68886e6a724.png', // 菜品图片url
    //     status: 2, // 座位用户状态1:未接锁，2:待，3:已
    //     dishRewardList: [
    //       // 当前菜品对应的奖励
    //       {
    //         id: 1, // 奖励id
    //         url: 'https://www.cdnmole.com/test/cms/image/f754aa9bf894f0b54ec65c3aeded3701.jpeg', // 奖励url
    //         unit: 3, // 数量
    //         name: '100金币',
    //       },
    //       {
    //         id: 2,
    //         url: 'https://www.cdnmole.com/test/cms/image/f754aa9bf894f0b54ec65c3aeded3701.jpeg',
    //         unit: 1,
    //         name: '100金币',
    //       },
    //       {
    //         id: 3,
    //         url: 'https://www.cdnmole.com/test/cms/image/f754aa9bf894f0b54ec65c3aeded3701.jpeg',
    //         unit: 1,
    //         name: '100金币',
    //       },
    //     ],
    //   },
    // ],
    // pageNum: 1,
    // pageSize: 20,
    // isMore: false,
    // userRankList: [
    //   {
    //     userId: '1',
    //     nickName: 'sssssss',
    //     headUrl: 'https://www.cdnmole.com/test/cms/image/f754aa9bf894f0b54ec65c3aeded3701.jpeg',
    //     coinNum: 234230,
    //     coinRewardValue: 1,
    //     rank: 0,
    //     anchorList: [
    //       {
    //         headUrl: 'https://www.cdnmole.com/test/cms/image/f754aa9bf894f0b54ec65c3aeded3701.jpeg',
    //         userId: 1,
    //       },
    //     ],
    //     isDeleted: 0,
    //     desc: 100000,
    //   },
    //   {
    //     userId: '2',
    //     nickName: 'sssssss',
    //     headUrl: 'https://www.cdnmole.com/test/cms/image/f754aa9bf894f0b54ec65c3aeded3701.jpeg',
    //     coinNum: 435346546,
    //     coinRewardValue: 200000,
    //     rank: 0,
    //     anchorList: [
    //       {
    //         headUrl: 'https://www.cdnmole.com/test/cms/image/f754aa9bf894f0b54ec65c3aeded3701.jpeg',
    //         userId: 1,
    //       },
    //     ],
    //     isDeleted: 0,
    //     desc: 100000,
    //   },
    //   {
    //     userId: '3',
    //     nickName: 'sssssss',
    //     headUrl: 'https://www.cdnmole.com/test/cms/image/f754aa9bf894f0b54ec65c3aeded3701.jpeg',
    //     coinNum: 234230,
    //     coinRewardValue: 3,
    //     rank: 0,
    //     anchorList: [
    //       {
    //         headUrl: 'https://www.cdnmole.com/test/cms/image/f754aa9bf894f0b54ec65c3aeded3701.jpeg',
    //         userId: 1,
    //       },
    //     ],
    //     isDeleted: 0,
    //     desc: 100000,
    //   },
    //   {
    //     userId: '4',
    //     nickName: 'sssssss',
    //     headUrl: 'https://www.cdnmole.com/test/cms/image/f754aa9bf894f0b54ec65c3aeded3701.jpeg',
    //     coinNum: 5645645,
    //     rank: 0,
    //     anchorList: [
    //       {
    //         headUrl: 'https://www.cdnmole.com/test/cms/image/f754aa9bf894f0b54ec65c3aeded3701.jpeg',
    //         userId: 1,
    //       },
    //     ],
    //     isDeleted: 0,
    //   },
    // ],
    // personalRank: {
    //   userId: 226622859,
    //   nickName: 'sssssss',
    //   headUrl: 'https://www.cdnmole.com/test/cms/image/f754aa9bf894f0b54ec65c3aeded3701.jpeg',
    //   coinNum: 234230,
    //   rank: 0,
    //   coinRewardValue: 3,
    //   anchorList: [
    //     {
    //       headUrl: 'https://www.cdnmole.com/test/cms/image/f754aa9bf894f0b54ec65c3aeded3701.jpeg',
    //       userId: 1,
    //     },
    //   ],
    //   isDeleted: 0,
    // },
    // rewardList: [
    //   {
    //     url: 'https://www.cdnmole.com/test/cms/image/f754aa9bf894f0b54ec65c3aeded3701.jpeg',
    //     unit: 1,
    //     name: '100金币',
    //   },
    //   {
    //     url: 'https://www.cdnmole.com/test/cms/image/f754aa9bf894f0b54ec65c3aeded3701.jpeg',
    //     unit: 1,
    //     name: '100金币',
    //   },
    //   {
    //     url: 'https://www.cdnmole.com/test/cms/image/f754aa9bf894f0b54ec65c3aeded3701.jpeg',
    //     unit: 1,
    //     name: '100金币',
    //   },
    //   {
    //     url: 'https://www.cdnmole.com/test/cms/image/f754aa9bf894f0b54ec65c3aeded3701.jpeg',
    //     unit: 1,
    //     name: '100金币',
    //   },
    //   {
    //     url: 'https://www.cdnmole.com/test/cms/image/f754aa9bf894f0b54ec65c3aeded3701.jpeg',
    //     unit: 1,
    //     name: '100金币',
    //   },
    // ],
    // topOneUserList: [
    //   [
    //     {
    //       id: 1, // 座位用户位置
    //       name: 'John', // 座位用户姓名
    //       url: 'https://www.cdnmole.com/test/cms/image/f754aa9bf894f0b54ec65c3aeded3701.jpeg', // 座位用户头像
    //       userId: 1, // 用户userId
    //       date: '4.19',
    //     },
    //     {
    //       id: 2,
    //       name: 'Mary',
    //       url: 'https://www.cdnmole.com/test/cms/image/f754aa9bf894f0b54ec65c3aeded3701.jpeg',
    //       userId: 1, // 用户userId
    //       date: '4.20',
    //     },
    //   ],
    //   [],
    //   [],
    //   [],
    //   [],
    // ],
    // unLockList: [
    //   [
    //     {
    //       id: 1, // 座位用户位置
    //       name: 'John', // 座位用户姓名
    //       url: 'https://www.cdnmole.com/test/cms/image/f754aa9bf894f0b54ec65c3aeded3701.jpeg', // 座位用户头像
    //       userId: 1, // 用户userId
    //       date: '4.19',
    //       sceneUrl: 'https://www.cdnmole.com/online/cms/image/c826b12beff31347ec47273779b2dc6c.png',
    //     },
    //     {
    //       id: 2,
    //       name: 'Mary',
    //       url: 'https://www.cdnmole.com/test/cms/image/f754aa9bf894f0b54ec65c3aeded3701.jpeg',
    //       userId: 1, // 用户userId
    //       date: '4.20',
    //       sceneUrl: 'https://www.cdnmole.com/online/cms/image/c826b12beff31347ec47273779b2dc6c.png',
    //     },
    //   ],
    //   [
    //     {
    //       id: 1, // 座位用户位置
    //       name: 'John', // 座位用户姓名
    //       url: 'https://www.cdnmole.com/test/cms/image/f754aa9bf894f0b54ec65c3aeded3701.jpeg', // 座位用户头像
    //       userId: 1, // 用户userId
    //       date: '4.19',
    //       sceneUrl: 'https://www.cdnmole.com/online/cms/image/84094ef569b127787dbb1c0c07bc5b27.png',
    //     },
    //     {
    //       id: 2,
    //       name: 'Mary',
    //       url: 'https://www.cdnmole.com/test/cms/image/f754aa9bf894f0b54ec65c3aeded3701.jpeg',
    //       userId: 1, // 用户userId
    //       date: '4.20',
    //       sceneUrl: 'https://www.cdnmole.com/online/cms/image/84094ef569b127787dbb1c0c07bc5b27.png',
    //     },
    //   ],
    // ],

    activityId: '',
    title: '',
    titleUrl: '',
    activityStatus: null,
    endTime: 0,
    rules: '',
    ruleUrl: '',
    limitedGifts: [],
    dailyRewards: [],
    totalRewards: [],
    id: '', // 菜品id
    url: '', // 菜品图片
    currentCoin: 0, // 当前金币
    endCoin: 0, // 总金币
    startCoin: 0, // 当前总的金币池
    tableDisplayList: [],
    dishInfoList: [],
    pageNum: 1,
    pageSize: 20,
    isMore: false,
    userRankList: [],
    personalRank: {},
    rewardList: [],
    topOneUserList: [],
    unLockList: [],
    totalTopOne: [],
  },
  reducers: {
    updateInfo(state, { payload }) {
      return {
        ...state,
        activityId: payload.activityId || 0,
        title: payload.title || '',
        titleUrl: payload.titleUrl || '',
        activityStatus: payload.activityStatus || 0,
        endTime: payload.endTime || 0,
        rules: payload.rules || '',
        ruleUrl: payload.ruleUrl || '',
        limitedGifts: payload.limitedGifts || [],
        dailyRewards: payload.dailyRewards || [],
        totalRewards: payload.totalRewards || [],
        rewardList: payload.rewardList || [],
      };
    },
    updateDishInfo(state, { payload }) {
      return {
        ...state,
        id: payload.id,
        url: payload.url,
        currentCoin: payload.currentCoin,
        endCoin: payload.endCoin,
        startCoin: payload.startCoin,
        tableDisplayList: payload.tableDisplayList,
        dishInfoList: payload.dishInfoList,
        topOneUserList: payload.topOneUserList || [],
        totalTopOne: payload.totalTopOne || [],
      };
    },
    updateRankList(state, { payload }) {
      let newList = payload.force ? [] : [...state.userRankList];
      if (payload.userRankList && payload.userRankList.length) {
        newList = [...newList, ...payload.userRankList];
      }
      return {
        ...state,
        userRankList: newList,
        personalRank: payload.personalRank || {},
        pageNum: payload.pageNum,
        isMore: newList.length < payload.total,
      };
    },
    updateUnlockList(state, { payload }) {
      return {
        ...state,
        unLockList: payload || [],
      };
    },
  },
  effects: {
    *getInfo({ payload }, { call, put }) {
      const { error, data } = yield call(cpListInfo, payload);
      if (error || !data) {
        yield put({
          type: 'updateInfo',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      console.log('data', data);
      yield put({
        type: 'updateInfo',
        payload: data,
      });
      return true;
    },
    *getDishInfo({ payload }, { call, put }) {
      const { error, data } = yield call(cpListDishInfo, payload);
      if (error || !data) {
        yield put({
          type: 'updateDishInfo',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateDishInfo',
        payload: data,
      });
      return true;
    },
    *collect({ payload }, { call }) {
      const { error, data, code } = yield call(cpListCollect, payload);
      if (error) {
        Toast.show({
          content: error,
        });
        return {
          success: false,
          error,
          code,
        };
      }
      return {
        success: true,
        data,
      };
    },
    *getRankList({ payload }, { call, put, select }) {
      const { pageNum, pageSize } = yield select(state => state.cpList);
      const { error, data } = yield call(cpListRank, {
        ...payload,
        pageNum: payload.force ? 1 : pageNum,
        pageSize: pageSize,
        force: undefined,
      });
      if (error || !data) {
        yield put({
          type: 'updateRankList',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateRankList',
        payload: { ...data, pageNum: payload.force ? 2 : pageNum + 1, force: payload.force, type: payload.type },
      });
      return true;
    },
    *getUnlockScence({ payload }, { call, put }) {
      const { error, data } = yield call(cpListShowUnlockScenet, payload);
      if (error || !data) {
        yield put({
          type: 'updateUnlockList',
          payload: [],
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateUnlockList',
        payload: data,
      });
      return true;
    },
  },
};
